import type { Schema, Permissions } from '@wix/wix-data-schema-types'
import { PermissionRole } from '@wix/wix-data-schema-types'
import { Preset, getPermissionsByPreset } from './permissionsPresets'

const publicRoles: PermissionRole[] = [
  PermissionRole.anyone,
  PermissionRole.siteMember,
  PermissionRole.siteMemberAuthor,
  PermissionRole.admin,
]

const operations: Array<keyof Permissions> = [
  'insert',
  'update',
  'remove',
  'read',
]

const withDefaultPermissions = (schema: Schema) => ({
  ...schema,
  permissions: getPermissionsByPreset(Preset.PRIVATE_DATA),
})

const containsRequiredProperties = (permissions: Permissions) =>
  operations.every((operation: keyof Permissions) =>
    publicRoles.includes(permissions[operation] as PermissionRole),
  )

export const ensurePermissions = (schema: Schema) => {
  if (!schema.permissions) {
    return withDefaultPermissions(schema)
  }

  if (!containsRequiredProperties(schema.permissions)) {
    return withDefaultPermissions(schema)
  }

  return schema
}
